import * as React from "react";
import { IconButton } from "@chakra-ui/react";
import { IoCloudUploadOutline } from "react-icons/io5";
import { Modal } from "components";
import { Discard } from "./components";
import { usePublish } from "./duck";

interface PublishButtonProps {
  id: number;
  name: string;
}

const PublishButton: React.FC<PublishButtonProps> = ({ id, name }) => {
  const onPublish = usePublish(id);

  return (
    <Modal.Confirm
      confirmColorScheme="blue"
      title="Publish saved changes"
      body={`Do you want to publish saved changes to the case '${name}'? You will not be able to undo this action.`}
      onConfirm={onPublish}
      successMessage="Saved changes are published successfully."
      confirmText="Publish"
      footerExtra={onClose => <Discard onSuccess={onClose} id={id} />}
      minW="600px"
    >
      <IconButton
        zIndex={1}
        width="16px"
        height="16px"
        minW="auto"
        display="flex"
        mt="0px"
        color="basic.500"
        justifyContent="center"
        position="absolute"
        top="8px"
        right="8px"
        aria-label="Upload"
        variant="unstyled"
        icon={<IoCloudUploadOutline />}
      />
    </Modal.Confirm>
  );
};

export default PublishButton;
